import React, { useContext } from 'react';
import { OneLPSsdkParamsContext } from '../../../onelps-sdk-params-context';

const GAMEID_TO_WIKI_URL = {
	'foe': '*.wiki.forgeofempires.com',
	'onyx': '*.wiki.elvenar.com',
	'grepo': 'wiki.*.grepolis.com',
};

function WikiLink( ) {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const wikiUrl = GAMEID_TO_WIKI_URL[onelpsParams.gameId]?.replace('*', onelpsParams.marketId);

	return (
		<a
			href={wikiUrl ? `https://${wikiUrl}` : ''}
			target="_blank"
			rel="noopener noreferrer"
		>
			Wiki
		</a>
	);
}

export default WikiLink;